import { createAction } from 'redux-act';
import { ApplicationSort } from '../../constants/types/api/application';
import { IErrorType } from '../../constants/types/error/error.types';
import {
    IApplyToAudition,
    IAuditionApplication,
    IAuditionFilter,
    ICreateCastingDirector,
    IGetAudition,
    IGetSimilarAuditions,
    IUpdateAudition,
    IUpdateCastingDirector,
    types,
    IManageAuditionParams,
    IUpdateRole,
} from './types';
import { IAudition, ICastingDirector, IGenericDocumentModifier, IRole, IRoleCreator } from '../../types/global/helper';
import { IEventFilter } from '../events/types';

export interface IGetAuditions {
    url?: string;
    page?: number;
    limit?: number;
}
interface IGetAuditionsResponse {
    data: any;
    isLoadMore: boolean;
}

// General Audition Actions
export const getAllAuditions = createAction<IGetAuditions | undefined>(types.GET_ALL_AUDITIONS);
export const getAllAuditionsSuccess = createAction<IGetAuditionsResponse>(types.GET_ALL_AUDITION_SUCCESS);
export const getAllAuditionsFailed = createAction<IErrorType>(types.GET_ALL_AUDITION_FAILED);

export const getAuditionsDetails = createAction<IGetAudition>(types.GET_AUDITION_DETAIL);
export const getAuditionsDetailsSuccess = createAction<any>(types.GET_AUDITION_DETAIL_SUCCESS);
export const getAuditionsDetailsFailed = createAction<IErrorType>(types.GET_AUDITION_DETAIL_FAILED);

export const applyToAudition = createAction<IApplyToAudition>(types.APPLY_TO_AUDITION);
export const applyToAuditionSuccess = createAction<IAuditionApplication>(types.APPLY_TO_AUDITION_SUCCESS);
export const applyToAuditionFailed = createAction<IErrorType>(types.APPLY_TO_AUDITION_FAILED);

export const addAuditionToWatchList = createAction(types.ADD_AUDITION_TO_WATCHLIST);
export const addAuditionToWatchListSuccess = createAction<any>(types.ADD_AUDITION_TO_WATCHLIST_SUCCESS);
export const addAuditionToWatchListFailed = createAction<IErrorType>(types.ADD_AUDITION_TO_WATCHLIST_FAILED);

export const getAuditionRoles = createAction<any>(types.GET_ROLES);
export const getAuditionRolesSuccess = createAction<any>(types.GET_ROLES_SUCCESS);
export const getAuditionRolesFailed = createAction<IErrorType>(types.GET_ROLES_FAILED);

export const getMyApplications = createAction(types.GET_MY_APPLICATIONS);
export const getMyApplicationsSuccess = createAction<any>(types.GET_MY_APPLICATIONS_SUCCESS);
export const getMyApplicationsFailed = createAction<IErrorType>(types.GET_MY_APPLICATIONS_FAILED);

// Filter Actions
export const toggleFilter = createAction(types.TOGGLE_FILTER);
export const addFilter = createAction<IAuditionFilter | IEventFilter | undefined>(types.ADD_FILTER);
export const removeFilter = createAction(types.REMOVE_FILTER);

// Collection Actions
export const saveCollection = createAction<any>(types.SAVE_COLLECTION);
export const saveCollectionSuccess = createAction<any>(types.SAVE_COLLECTION_SUCCESS);
export const saveCollectionFail = createAction<IErrorType>(types.SAVE_COLLECTION_FAIL);

export const getSavedCollection = createAction(types.GET_SAVED_COLLECTION);
export const getSavedCollectionSuccess = createAction<any>(types.GET_SAVED_COLLECTION_SUCCESS);
export const getSavedCollectionFail = createAction<IErrorType>(types.GET_SAVED_COLLECTION_FAIL);

export const deleteSavedCollection = createAction<string>(types.DELETE_SAVED_COLLECTION);
export const deleteSavedCollectionSuccess = createAction<string>(types.DELETE_SAVED_COLLECTION_SUCCESS);
export const deleteSavedCollectionFail = createAction<IErrorType>(types.DELETE_SAVED_COLLECTION_FAIL);

export const updateSavedCollection = createAction<any>(types.UPDATE_SAVED_COLLECTION);
export const updateSavedCollectionSuccess = createAction<any>(types.UPDATE_SAVED_COLLECTION_SUCCESS);
export const updateSavedCollectionFail = createAction<IErrorType>(types.UPDATE_SAVED_COLLECTION_FAIL);

// Audition Management Actions
export const createAudition = createAction<any>(types.CREATE_AUDITION);
export const createAuditionSuccess = createAction<any>(types.CREATE_AUDITION_SUCCESS);
export const createAuditionFail = createAction<IErrorType>(types.CREATE_AUDITION_FAIL);

export const createRole = createAction<{ auditionId: string; body: IRoleCreator }>(types.CREATE_ROLE);
export const createRoleSuccess = createAction<any>(types.CREATE_ROLE_SUCCESS);
export const createRoleFail = createAction<IErrorType>(types.CREATE_ROLE_FAIL);

export const updateRole = createAction<IUpdateRole>(types.UPDATE_ROLE);
export const updateRoleSuccess = createAction<IRole>(types.UPDATE_ROLE_SUCCESS);
export const updateRoleFail = createAction<IErrorType>(types.UPDATE_ROLE_FAIL);

export const updateAudition = createAction<IUpdateAudition>(types.UPDATE_AUDITION);
export const updateAuditionSuccess = createAction<any>(types.UPDATE_AUDITION_SUCCESS);
export const updateAuditionFail = createAction<IErrorType>(types.UPDATE_AUDITION_FAIL);

export const deleteRole = createAction<any>(types.DELETE_ROLE);
export const deleteRoleSuccess = createAction<any>(types.DELETE_ROLE_SUCCESS);
export const deleteRoleFail = createAction<IErrorType>(types.DELETE_ROLE_FAIL);

export const publishAudition = createAction<any>(types.PUBLISH_AUDITION);
export const publishAuditionSuccess = createAction<any>(types.PUBLISH_AUDITION_SUCCESS);
export const publishAuditionFail = createAction<IErrorType>(types.PUBLISH_AUDITION_FAIL);

export const unPublishAudition = createAction<any>(types.UNPUBLISH_AUDITION);
export const unPublishAuditionSuccess = createAction<any>(types.UNPUBLISH_AUDITION_SUCCESS);
export const unPublishAuditionFail = createAction<IErrorType>(types.UNPUBLISH_AUDITION_FAIL);

export const deleteAudition = createAction<any>(types.DELETE_AUDITION);
export const deleteAuditionSuccess = createAction<any>(types.DELETE_AUDITION_SUCCESS);
export const deleteAuditionFail = createAction<IErrorType>(types.DELETE_AUDITION_FAIL);

export const setAuditionForEdit = createAction<any>(types.SET_AUDITION_FOR_EDIT);
export const setAuditionToManage = createAction<any>(types.SET_AUDITION_TO_MANAGE);
export const setApplicationsToManage = createAction<any>(types.SET_APPLICATIONS_TO_MANAGE);

export const getAllApplicationForAudition = createAction<any>(types.GET_ALL_APPLICATION_FOR_AUDITION);
export const getAllApplicationForAuditionSuccess = createAction<any>(types.GET_ALL_APPLICATION_FOR_AUDITION_SUCCESS);
export const getAllApplicationForAuditionFail = createAction<IErrorType>(types.GET_ALL_APPLICATION_FOR_AUDITION_FAIL);

export const sortApplication = createAction<ApplicationSort>(types.SORT_APPLICATION);
export const sortApplicationSuccess = createAction<ApplicationSort>(types.SORT_APPLICATION_SUCCESS);
export const sortApplicationFail = createAction<IErrorType>(types.SORT_APPLICATION_FAIL);

export const setRole = createAction<IRole | undefined>(types.SET_ROLE);
export const setAudition = createAction<IAudition | undefined>(types.SET_AUDITION);

type IFilterAuditions = {
    distance?: number;
    lat?: number;
    lng?: number;
    unit?: string;
    rehearsal_date_start?: Date;
    rehearsal_date_end?: Date;
    tags?: string;
    audition_type?: string;
    required_skill?: string;
    compensation?: string;
    employment_type?: string;
    min_age?: number;
    max_age?: number;
};

interface ISearchAudition {
    searchTerm: string;
}

export interface LoadMoreAction {
    limit: number;
    page: number;
}

type Query = {
    limit: number;
    page: number;
};

export interface ILoadMoreResponse {
    data: Array<IAudition>;
    query: Query;
}

export interface IWithdrawApplication {
    applicationId: string;
}

export const setAuditionDetails = createAction<any>(types.SET_AUDITION_DETAILS);

export const filterAudition = createAction<IFilterAuditions>(types.FILTER_AUDITION);
export const filterAuditionSuccess = createAction<Array<IAudition>>(types.FILTER_AUDITION_SUCCESS);
export const filterAuditionFail = createAction<IErrorType>(types.FILTER_AUDITION_FAIL);

export const auditionAdvancedSearch = createAction<ISearchAudition>(types.ADVANCED_AUDITION_SEARCH);
export const auditionAdvancedSearchSuccess = createAction<Array<IAudition>>(types.ADVANCED_AUDITION_SEARCH_SUCCESS);
export const auditionAdvancedSearchFail = createAction<IErrorType>(types.ADVANCED_AUDITION_SEARCH_FAIL);

export const loadMoreAudition = createAction<LoadMoreAction>(types.LOAD_MORE_AUDITIONS);
export const loadMoreAuditionSuccess = createAction<ILoadMoreResponse>(types.LOAD_MORE_AUDITIONS_SUCCESS);
export const loadMoreAuditionFail = createAction<IErrorType>(types.LOAD_MORE_AUDITIONS_FAIL);

export const withdrawApplication = createAction<IWithdrawApplication>(types.WITHDRAW_APPLICATION);
export const withdrawApplicationSuccess = createAction<IWithdrawApplication>(types.WITHDRAW_APPLICATION_SUCCESS);
export const withdrawApplicationFail = createAction<IErrorType>(types.WITHDRAW_APPLICATION_FAIL);
export const resetAuditionData = createAction(types.RESET_AUDTION_DATA);

export const getSimilarAuditions = createAction<IGetSimilarAuditions>(types.GET_SIMILAR_AUDITION);
export const getSimilarAuditionsSuccess = createAction<IAudition[]>(types.GET_SIMILAR_AUDITION_SUCCESS);
export const getSimilarAuditionsFail = createAction<IErrorType>(types.GET_SIMILAR_AUDITION_FAIL);

export const createCastingDirector = createAction<ICreateCastingDirector>(types.CREATE_CASTING_DIRECTOR);
export const createCastingDirectorSuccess = createAction<ICastingDirector>(types.CREATE_CASTING_DIRECTOR_SUCCESS);
export const createCastingDirectorFail = createAction<IErrorType>(types.CREATE_CASTING_DIRECTOR_FAIL);

export const getCastingDirectors = createAction(types.GET_CASTING_DIRECTOR);
export const getCastingDirectorsSuccess = createAction<ICastingDirector[]>(types.GET_CASTING_DIRECTOR_SUCCESS);
export const getCastingDirectorsFail = createAction<IErrorType>(types.GET_CASTING_DIRECTOR_FAIL);

export const updateCastingDirector = createAction<IUpdateCastingDirector>(types.UPDATE_CASTING_DIRECTOR);
export const updateCastingDirectorSuccess = createAction<ICastingDirector>(types.UPDATE_CASTING_DIRECTOR_SUCCESS);
export const updateCastingDirectorFail = createAction<IErrorType>(types.UPDATE_CASTING_DIRECTOR_FAIL);

export const deleteCastingDirector = createAction<IGenericDocumentModifier>(types.DELETE_CASTING_DIRECTOR);
export const deleteCastingDirectorSuccess = createAction<IGenericDocumentModifier>(
    types.DELETE_CASTING_DIRECTOR_SUCCESS,
);
export const deleteCastingDirectorFail = createAction<IErrorType>(types.DELETE_CASTING_DIRECTOR_FAIL);

export const manageAudition = (params: IManageAuditionParams) => {
    return {
        type: types.MANAGE_AUDITION,
        payload: params,
    };
};

export const manageAuditionSuccess = (payload: any) => ({
    type: types.MANAGE_AUDITION_SUCCESS,
    payload,
});

export const manageAuditionFail = (payload: any) => ({
    type: types.MANAGE_AUDITION_FAIL,
    payload,
});
